import { z } from "zod";

const resetPasswordSchema = z.object({
	password: z.string().min(6).max(120),
	token: z.string()
});

export type iResetPassword = z.infer<typeof resetPasswordSchema>;

export { resetPasswordSchema };
